import React,{useContext, useEffect} from 'react';
import userStoryImage2 from '../../assets/img/feed-imgs/center/story/story-user2.png';
import userStoryImage3 from '../../assets/img/feed-imgs/center/story/story-user3.png';
import userStoryImage4 from '../../assets/img/feed-imgs/center/story/story-user4.png';
import userStoryImage5 from '../../assets/img/feed-imgs/center/story/story-user5.png';
import userStoryImage6 from '../../assets/img/feed-imgs/center/story/story-user6.png';
import userStoryImage7 from '../../assets/img/feed-imgs/center/story/story-user4.png';
import userStoryImage8 from '../../assets/img/feed-imgs/center/story/story-user2.png';
import userStoryImage9 from '../../assets/img/feed-imgs/center/story/story-user1.png';
import live from '../../assets/img/feed-imgs/left/live-streaming.svg';
import MainMenu from '../../components/mainMenu/MainMenu';
import RightSitebarMenu from '../../components/rightSitebarMenu/RightSitebarMenu';
import rightArrow from '../../assets/img/feed-imgs/center/story/arrow-right.svg';
import LivePageSingleElement from './LivePageSingleElement/LivePageSingleElement';
import FilterAndShort from '../../components/filterAndShort/FilterAndShort';
import LeftSitebarMenu from './../../components/leftSitebarMenu/LeftSitebarMenu';
import closerIcon from '../../assets/img/feed-imgs/navbar/closeicon.svg';
import { ShowHideSitebar } from './../../App';

const Live = () => {
    
    const liveStatus = [
        {
            userName : "Lilly N",
            userImage: userStoryImage2
        },
        {
            userName : "A Robben",
            userImage: userStoryImage3
        },
        {
            userName : "Serena Nadal",
            userImage: userStoryImage4
        },
        {
            userName : "Richa Luis",
            userImage: userStoryImage5
        },
        {
            userName : "Sam DaSilva",
            userImage: userStoryImage6
        },
        {
            userName : "Lilly N",
            userImage: userStoryImage7
        },
        {
            userName : "A Robben",
            userImage: userStoryImage8
        },
        {
            userName : "Serena Nadal",
            userImage: userStoryImage9
        }
     ]
     const [showHideSidebar, setShowHideSidebar] = useContext(ShowHideSitebar)
     useEffect(()=>{ /** setting the page name for the sidebars of this page to work */
         const setPageName = {...showHideSidebar}
         setPageName.pageName = 'live';
         setPageName.live.left = false;
         setPageName.live.right = false;
         setShowHideSidebar(setPageName)
         // eslint-disable-next-line react-hooks/exhaustive-deps
     }, [])
     const closeSidebar =(whichSidebar, status)=>{
         const newStatus = {...showHideSidebar}
         if(whichSidebar === 'left'){
             newStatus.live.left = status /** changing the page name for left sidebar to toggle */
             setShowHideSidebar(newStatus) /** changing the page name for right sidebar to toggle */
         }
         if(whichSidebar === 'right'){
             newStatus.live.right = status
             setShowHideSidebar(newStatus)
         }
     }
    return (
        <>
           <MainMenu></MainMenu>
            {/* Menu bar start here */}
            <div className="container-fluid container-lg">
                <div className="row gap-5 gap-lg-0">
                    {/* Left Site Bar Start here */}
                    {/* <div className={`col-12 col-lg-2 d-lg-flex flex-column gap-4  ${showHideSidebar?.live.left ? 'd-block right-sitebarmenu' : 'd-none' }`}>
                        <div className="d-flex d-lg-none justify-content-end mb-3">
                            <div onClick={()=>closeSidebar("left", false)} className="d-flex justify-content-center align-items-center action-button rounded-circle bg-white shadow-sm p-2 fixed-top" style={{ height: "32px", width: "32px"}}>
                                <img className="img-fluid" src="" alt='' />
                            <LeftSitebarMenu></LeftSitebarMenu>
                            </div>
                        </div>
                    </div> */}
                    <div className={`col-12 col-lg-2  d-lg-block ${showHideSidebar?.live?.left ? 'd-block right-sitebarmenu' : 'd-none'}`}>
                        <div className="d-flex d-lg-none justify-content-end mb-3">
                            <div onClick={()=>closeSidebar("left", false)} className="d-flex justify-content-center align-items-center action-button rounded-circle shadow-sm p-2 m-3" style={{ height: "32px", width: "32px"}}>
                                <img src={closerIcon} alt="" className='close-menu-button' />
                            </div>
                        </div>
                        <LeftSitebarMenu></LeftSitebarMenu>
                    </div>    
                    {/* left Site Bar End Hre */}
                            {/* Live Page Center Eliments */}
                            <div className="col-lg-6">
                                {/* Show How Many People Are Live */}
                                <div className="row">
                                    <div className="d-flex">
                                        <div className='d-flex gap-2 story-div-show pb-3'>
                                                {
                                                    liveStatus.map( (items, index ) => <div className="col-3 col-lg-2 text-center position-relative" key={index}>
                                                            <img className="w-100 story-image-design " src={items.userImage} alt="" />
                                                            <h1 className="stry-un live-badge">live</h1>
                                                        </div>
                                                    )
                                                }
                                        </div>
                                        <div className="story-icon-border col-lg-1 col-2 ms-2">
                                                <div className="story-border-fill position-absolute top-50 start-50 translate-middle">
                                                    <div className="position-absolute top-50 start-50 translate-middle">
                                                        <img src={rightArrow} alt="" />
                                                    </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Button and filter Section in here  */}
                                <div className="row my-4">
                                    {/* Filter and Short Seciton Component */}
                                        <div className="mb-3" style={{height: "1px",background: "#707070"}}></div>
                                        <div className="row mb-5 gap-2 gap-lg-0">
                                            <div className="col-12 col-lg-8 col-md-6">
                                                <button className="custm-pill-button-small rounded-pill px-3 py-2 post_btn d-flex align-items-center" type="button"> <img src={live} alt="" className='me-3' /> Go Live</button>
                                            </div>
                                            <div className="col-12 col-lg-4 d-flex justify-content-start justify-content-lg-end align-items-start gap-4">
                                                <FilterAndShort></FilterAndShort>
                                            </div>
                                        </div>
                                </div>

                                {/* Live People Show Status *** Single People Single single Live Status Show*/}
                                <LivePageSingleElement></LivePageSingleElement>
                               
                                
                            </div>
                            <div className={`col-12 col-lg-4  d-lg-block ${showHideSidebar?.live?.right ? 'd-block right-sitebarmenu' : 'd-none'}`}>
                            <div className="d-flex d-lg-none justify-content-end mb-3">
                                <div onClick={()=>closeSidebar("right", false)} className="d-flex justify-content-center align-items-center action-button rounded-circle shadow-sm p-2 m-3" style={{ height: "32px", width: "32px"}}>
                                    <img src={closerIcon} alt="" className='close-menu-button' />
                                </div>
                            </div>
                        <RightSitebarMenu />
                    </div>
                   
                </div>
           </div>
        </>
    );
};

export default Live;